import { useFrontendTool } from "@copilotkit/react-core"
import { NATSPublish } from "plugins/nats"
import farmSo from "stores/farm"
import dialogSo, { DIALOG_TYPE } from "stores/layout/dialogStore"
import { ADJ_PROPS } from "stores/plc/utils/adj"
import { TOOLS } from "./utils/types"
import userSo from "stores/user"



/**
 * utilizzata per settare i valori dei PLC-VALUE dell'HARDWARE di una specifica GROWUNIT.
 */
export function useSetValues() {

	useFrontendTool({
		name: "set_growunit_plc_values",
		description: `Setta il valore di un PLC-VALUE dell'HARDWARE di una specifica GROWUNIT.
ATTENZIONE: deve essere selezionata una FARM (tool: ${TOOLS.NAVIGATE_IN_FARM_SECTION}) prima di poter usare questo tool.
BONUS: se il fine ultimo è settare i valori visualizza la corretta GROWUNIT e GROWUNIT-SECTION (tool: ${TOOLS.NAVIGATE_IN_GROWUNIT_SECTION}) in maniera che l'utente possa controllare.
i PLC-VALUES che possono essere settati sono (per esempio: "PH-SETPOINT" per settare il valore di acidità):
- PH-SETPOINT: acidità nutrimento
- EC-SETPOINT: elettroconduttività del nutrimento
`,
		parameters: [
			{
				name: "growunit_code",
				description: "il code della GROWUNIT",
				type: "string",
				required: true,
			},
			{
				name: "plc_value_name",
				description: "Il nome del PLC-VALUE.",
				type: "string",
				required: true,
			},
			{
				name: "value",
				description: "Il valore da settare.",
				type: "number",
				required: true,
			},
		],
		handler: async ({ growunit_code, plc_value_name, value }) => {
			if (farmSo.state.select == null) return {
				success: false,
				error: `Devi selezionare una FARM prima. Usa il tool ${TOOLS.NAVIGATE_IN_FARM_SECTION} per selezionare una FARM e poi ripeti questa azione.`
			}
			const component = farmSo.getComponentByCode(growunit_code) ?? farmSo.getComponentByGrowUnitCode(growunit_code)
			const code = component?.subjects?.[0]
			if (!component || !code) return {
				success: false,
				error: `Nessun COMPONENT associato alla GROWUNIT con code "${growunit_code}" o subject errato "${code}".`
			}
			let alias: string = null
			let propName = ""
			switch (plc_value_name) {
				case "PH-SETPOINT":
					alias = ADJ_PROPS.PH_SETPOINT
					propName = "PH"
					break;
				case "EC-SETPOINT":
					alias = ADJ_PROPS.EC_SETPOINT
					propName = "EC"
					break;
				default:
					return {
						success: false,
						error: `Il PLC-VALUE "${plc_value_name}" non è settabile tramite questo tool o non esiste.`
					}
			}
			if (alias == null) return {
				success: false,
				error: `Il PLC-VALUE "${plc_value_name}" non è settabile tramite questo tool o non esiste.`
			}
			const res = await dialogSo.dialogOpen({
				type: DIALOG_TYPE.WARNING,
				title: `CONFERMA AZIONE SU FARM ${farmSo.state.select.name} - ${component.name}`,
				text: `Stai per settare il ${propName} al valore ${value}.\nSei sicuro di voler procedere?`,
			})
			if (!res) return {
				success: false,
				error: `Azione annullata dall'utente.`
			}
			NATSPublish(code, alias, value)
			return {
				success: true,
				data: `Valore "${value}" inviato al PLC-VALUE "${alias}" della GROWUNIT con code "${growunit_code}".`
			}
		},
		available: userSo.isReader() ? "disabled" : "enabled"
	})
}



